import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import theme from './theme';
import ContactFormApp from './ContactFormApp';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement!);
const normalizedPath = window.location.pathname.replace(/\/+$/, '');
const RootApp = normalizedPath === '/hello' ? ContactFormApp : App;

root.render(
  <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <RootApp />
  </ThemeProvider>,
);
